'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderOverviewComponent = exports.orderOverviewComponent = {
    template: require('./order-overview.html'),
    bindings: {
        input: '<',
        sellers: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "common", "gettextCatalog", "orderService", "exceptionService", "Paging", "config", "authService", "$stateParams", "$window", "cartService", "$state", "toastr", "Analytics", "Enums", function orderOverviewController($scope, common, gettextCatalog, orderService, exceptionService, Paging, config, authService, $stateParams, $window, cartService, $state, toastr, Analytics, Enums) {
        'ngInject';

        var vm = this;
        vm.orders = vm.input.orders;
        vm.searchValue = '';
        vm.paging = null;
        vm.sortProperty = 'OrderDate';
        vm.sortAsc = false;
        vm.isLoading = false;
        vm.isAddingToCart = false;
        vm.getOrders = getOrders;
        vm.search = search;
        vm.goToPage = goToPage;
        vm.changeSorting = changeSorting;
        vm.$onInit = init;
        vm.getDownloadUrl = getDownloadUrl;
        vm.reOrderProducts = reOrderProducts;
        vm.itemsPerPage = Enums.getAmounts.default;

        angular.element($window).on('keydown', function (event) {
            if (event.which === 13 && !vm.isLoading) {
                vm.getOrders();
            }
        });

        $scope.$on('$destroy', function () {
            angular.element($window).off('keydown');
        });

        function init() {
            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString('My orders'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/orders', gettextCatalog.getString('My orders'));

            vm.selectedSeller = vm.sellers[0];
            vm.paging = Paging.create({
                page: 1,
                itemsPerPage: vm.itemsPerPage,
                totalItems: vm.input.totalItems
            });
        }

        function getOrders() {
            common.log.info('search orders: searchValue ' + vm.searchValue + ', page ' + vm.paging.page + ', sort by ' + vm.sortProperty + ', sort asc ' + vm.sortAsc);

            vm.isLoading = true;
            orderService.getByCriteria(vm.searchValue, vm.paging.page, vm.itemsPerPage, vm.sortProperty, vm.sortAsc, vm.selectedSeller.id).then(function (result) {
                vm.orders = result.orders;
                vm.paging = Paging.create({
                    page: vm.paging.page,
                    itemsPerPage: vm.itemsPerPage,
                    totalItems: result.totalItems
                });
            }).catch(function () {
                var msg = gettextCatalog.getString('The orders could not be retrieved');
                exceptionService.logException(msg);
            }).finally(function () {
                return vm.isLoading = false;
            });
        }

        function search(e) {
            vm.searchValue = e.searchValue;
            vm.selectedSeller = e.selectedSeller;
            vm.paging.page = 1;
            getOrders();
        }

        function goToPage(page) {
            if (page === 0 || page > vm.paging.pageCount) {
                return;
            }
            vm.paging.page = page;
            getOrders();
        }

        function changeSorting(sortProperty) {
            vm.sortAsc = vm.sortProperty === sortProperty ? !vm.sortAsc : true;
            vm.sortProperty = sortProperty;
            vm.paging.page = 1;
            getOrders();
        }

        function getDownloadUrl(order) {
            return config.webApiBaseUrl + ('report/orderDetail/' + order.id + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }

        function reOrderProducts(order) {
            vm.isAddingToCart = true;
            cartService.reOrderProducts(order.id).then(function () {
                vm.isAddingToCart = false;

                toastr.success(gettextCatalog.getString('Added products to your shoppingcart'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                $state.go('cart');
            }).catch(function () {
                vm.isAddingToCart = false;

                toastr.error(gettextCatalog.getString('An error occured when adding products to your shoppingcart, please try again'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                var msg = gettextCatalog.getString('An error occurred during the re order. Please contact the customer support.');
                exceptionService.logException(msg);
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/order-overview.js
// module id = 869
// module chunks = 0